import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=0b553171&scoped=true"
import script from "./calculator.vue?vue&type=script&lang=js"
export * from "./calculator.vue?vue&type=script&lang=js"
import style0 from "./calculator.vue?vue&type=style&index=0&id=0b553171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b553171",
  null
  
)

/* custom blocks */
import block0 from "./calculator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HSvgIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-svg-icon.vue').default})
